import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Permission } from '../../types/Auth';

// Application...
import Home from '../../views/Home/Home';
// Public...
import {
    Login,
    PrivateRoute,
    RegisterView,
    PostRegister,
    NotFound,
    ResetPassView,
    NewPassView,
} from '../../views/public';

const AppRoutes: React.FC = (): React.ReactElement => {
    return (
        <Switch>
            <Route exact path={['/', '/login']} component={Login} />
            <Route exact path="/register" component={RegisterView} />
            <Route exact path="/postregister" component={PostRegister} />
            <Route exact path="/reset-password" component={ResetPassView} />
            <Route exact path="/new-password" component={NewPassView} />
            <PrivateRoute path="/admin" comp={Home} perm={Permission.ADMIN_PAGE_VIEW} />
            <Route path="*" component={NotFound} />
        </Switch>
    );
};

export default AppRoutes;
